import { render, staticRenderFns } from "./BlmCourseItem.vue?vue&type=template&id=0baebbd7&scoped=true"
import script from "./BlmCourseItem.vue?vue&type=script&lang=ts"
export * from "./BlmCourseItem.vue?vue&type=script&lang=ts"
import style0 from "./BlmCourseItem.vue?vue&type=style&index=0&id=0baebbd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baebbd7",
  null
  
)

export default component.exports